import State from '../interfaces/states/State';

import ExplorerCurrentCategory from '../interfaces/ExplorerCurrentCategory';

const userExplorerCurrentCategory$ = (state: State): ExplorerCurrentCategory => state.userExplorer.currentCategory;

export default userExplorerCurrentCategory$;
